export default "__VITE_ASSET__Mj5LsrxO__"